import React from "react";
import { NavLink } from "react-router-dom";

export default function Nav(props) {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="navbar-brand">
        <NavLink to="/" className="activeLink">
          <img
            src="/img/logo.png"
            width="30"
            height="30"
            className="d-inline-block"
            alt="Key Change Logo"
          />
          Key Change
        </NavLink>
      </div>
      <div>
        <ul className="navbar-nav ml-auto list-unstyled">
          {props.userUid ? (
            <>
              <li>
                <NavLink
                  to={`/profile/${props.userUid}`}
                  className="activeLink"
                >
                  {" "}
                  Profile
                </NavLink>
              </li>
            </>
          ) : (
            <>
              <li>
                <NavLink to="/" className="activeLink">
                  {" "}
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="login" className="activeLink">
                  Host Login
                </NavLink>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}
